module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAxOCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zIDIwSDJWMThIMFYxN1YwSDFIMTVIMTZWMkgxN0gxOFYxOVYyMEgzWk0xNSAxSDFWMTdIMTVWMVpNMTcgM0gxNlYxN1YxOEgzVjE5SDE3VjNaTTEzIDRIM1YzSDEzVjRaTTEzIDZIM1Y1SDEzVjZaTTEzIDhIM1Y3SDEzVjhaTTEzIDEwSDNWOUgxM1YxMFpNMTMgMTJIM1YxMUgxM1YxMlpNOSAxNEgzVjEzSDlWMTRaIiBmaWxsPSIjMDhCMUM0Ii8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/market/page.svg
// module id = 1939
// module chunks = 0